import React, { useEffect, useState } from "react";
import EntityTableTemplate from "../../MyUI/EntityTableTemplate/EntityTableTemplate";
import { usersConfig as baseConfig } from "./users_conf";
import { getGroups } from "../../../services/services";

export default function Users() {

  const [usersConfig, setParamsConfig] = useState(baseConfig);

  const fetchElements = async () => {
    try {
      const res = await getGroups();

      const combboxGroups = res.data;
      
      // Update formFields dynamically
      const updatedFormFields = baseConfig.formFields.map(f => {
        if (f.key === "groups") {
          return { ...f, MultiSelectAutocomplete: combboxGroups };
        }
        return f;
      });

      setParamsConfig({ ...baseConfig, formFields: updatedFormFields });
    } catch (err) {
      console.error("Error fetching groups:", err);
    }
  };
  
    useEffect(() => {
    fetchElements();
  }, []);

  const handleSaved = () => {
    fetchElements();
  };

  if (!usersConfig) return null;

  return <EntityTableTemplate config={usersConfig} onSaved2={handleSaved}/>;
}
